module.exports = {
  zh_CN: require('../#language/zh_CN.js'),
  en_US: require('../#language/en_US.js')
};
